export enum ValidationResponseCode {
    'VALIDATION_FAILED' = 'VALIDATION_FAILED',
    'VALIDATION_SUCCEEDED' = 'VALIDATION_SUCCEEDED',
}
